import { fork, takeEvery, takeLatest } from 'typed-redux-saga';
import reconcileGiftCardOnCartEntryChangeSaga, {
  reconcileGiftCardOnCartEntryChangeTriggerTypes
} from './reconcileGiftCardOnCartEntryChangeSaga';
import { changeCurrentCartTypeSucceededType } from '../../carts/cartsSlice';
import { hydrateType } from '@spa/lib/store/HydrateAction';
import reconcileEmployeeDiscountSaga from './reconcileEmployeeDiscountSaga';
import removeAnonymousCartIfTokenUserTypeMismatchSaga from './removeAnonymousCartIfTokenUserTypeMismatchSaga';
import { setTokensType } from '../../session/sessionSlice';
import syncFavoriteStoreOnCartTypeSwitchSaga from './syncFavoriteStoreOnCartTypeSwitchSaga';
import watchCurrentCartActionsSaga from './watchCurrentCartActionsSaga';
import watchCurrentCartsCookieChangesSaga from './watchCurrentCartsCookieChangesSaga';

function* cartSaga(): Generator {
  yield* fork(watchCurrentCartActionsSaga);
  yield* fork(watchCurrentCartsCookieChangesSaga);
  yield* fork(reconcileEmployeeDiscountSaga);
  yield* takeLatest([setTokensType, hydrateType], removeAnonymousCartIfTokenUserTypeMismatchSaga);
  yield* takeEvery(changeCurrentCartTypeSucceededType, syncFavoriteStoreOnCartTypeSwitchSaga);
  yield* takeEvery(
    reconcileGiftCardOnCartEntryChangeTriggerTypes,
    reconcileGiftCardOnCartEntryChangeSaga
  );
}

export default cartSaga;
